<template lang="pug">
.back-order-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        //- CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='รายการ Back Order'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          v-model='filterDate'
        )

      .d-flex.align-items-end.px-4.py-2
        //- CustomCategoriesFilter(
        //-   title='เลือกดูรายการ'
        //-   :items='statusList'
        //-   v-model='filterStatus'
        //- )
        CustomSearchBox.ml-auto(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
          :isLoading='isLoading'
        )

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.scrollable.h-scrollable
        CustomTable.w-max-content(
          :columns='tableColumns'
          :data='filteredTableData'
          :showNotificationDots='true'

          :showIndexes='true'
          :itemClickable='false'
        )
          //- :showIndexes='true'
          //- :selectable='true'
          //- v-model='selectedItemsIndexes'
          //- @itemClicked='updateSelectedItems'

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )
    //- .sticky-bottom.bg-white.d-flex.mt-3
    //-   button.btn.btn-secondary.btn-not-rounded.py-3.flex-fill(
    //-     :disabled='shouldButtonsBeDisabled'
    //-     @click='showModalForAction(`CANCEL_ORDER`)'
    //-   )
    //-     | ยกเลิกรายการคงค้างที่เลือก
    //-   button.btn.btn-upa-secondary.btn-not-rounded.py-3.flex-fill(
    //-     :disabled='shouldButtonsBeDisabled'
    //-     @click='showModalForAction(`NEW_ORDER`)'
    //-   )
    //-     | ดำเนินการทำรายการขายที่เลือก

  //- modal(
  //-   name='back-order'
  //-   width='90%' height='95%'
  //-   transition='modal-transition'
  //- )
  //-   BackOrderDetail(
  //-     :customer='customer'
  //-     :backOrders='selectedItems'
  //-     :action='modalAction'
  //-     @closeButtonClicked='hideModal'
  //-     @backOrderCancelled='backOrderCancelled'
  //-     @newOrderCreated='makeASell'
  //-   )

  //- modal(
  //-   name='action-status'
  //-   width='480px' height='480px'
  //-   transition='modal-transition'
  //-   :clickToClose='false'
  //- )
  //-   StatusDialog(
  //-     type='cs.sellrecord.reject'
  //-     @closeButtonClicked='hideStatusDialog'
  //-   )

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import BackOrderDetail from '@/components/history/dialogs/BackOrder/BackOrderDetail.vue';
import QuotationDetail from '@/components/history/dialogs/Quotation/QuotationDetail.vue';

export default {
  props: {
    // customer: {
    //   default: () => ({}),
    // },
  },
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    customer() { this.currentPage = 1; this.loadData(); },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
      //     (!this.filterStatus || item.status.toString() === this.filterStatus)
      //     && (!KEYWORD
      //       || item.entryNo.toUpperCase().startsWith(KEYWORD)
      //       || item.productId.toUpperCase().startsWith(KEYWORD)
      //       || item.productName.toUpperCase().includes(KEYWORD)
      //     )
      //   );
      // });
      return this.tableData;
    },
    customer() {
      if (this.selectedItems && this.selectedItems[0]) {
        return this.selectedItems[0].customer;
      }
      return {};
    },
    shouldButtonsBeDisabled() {
      return !this.selectedItemsIndexes || this.selectedItemsIndexes.length === 0;
    },
  },
  data() {
    return {
      isLoading: false,

      /* eslint-disable quote-props */
      statusList: {
        0: 'รอสินค้า',
        1: 'พร้อม',
        // 2: 'ยกเลิก',
      },
      filterStatus: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        entryNo: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        productId: {
          title: 'รหัสสินค้า',
          align: 'left',
        },
        productName: {
          title: 'ชื่อสินค้า',
          align: 'left',
        },
        amount: {
          title: 'จำนวน',
          align: 'right',
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          computed(row) {
            if (row.product) {
              return Number(row.product.price);
            }
            return 0;
          },
        },
        status: {
          title: 'สถานะ',
          align: 'center',
          type: this.$api.customer.COL_TYPE.BackOrderStatus,
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItems: [],
      selectedItemsIndexes: [],
      modalAction: '',
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      try {
        const res = await this.$api.cs.sellRecord.backOrder(
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
          // console.log(this.tableData);
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    // updateSelectedItems(e) {
    //   // if (!this.selectedItems.includes(e))
    //   // this.selectedItem = e.data;
    //   // this.$modal.show('back-order');
    //   console.log(e);
    // },
    // showModalForAction(modalAction) {
    //   // create an array of selectedItems
    //   const selectedItems = [];
    //   for (let i = 0; i < this.selectedItemsIndexes.length; i += 1) {
    //     const INDEX = this.selectedItemsIndexes[i];
    //     selectedItems.push(this.tableData[INDEX]);
    //   }
    //   this.selectedItems = selectedItems;
    //   console.log(this.selectedItems);
    //   this.modalAction = modalAction;
    //   this.$modal.show('back-order');
    // },
    // hideModal(modalName = 'back-order') {
    //   this.$modal.hide(modalName);
    // },
    // backOrderCancelled() {
    //   this.hideModal();
    //   this.showStatusDialog();

    //   this.selectedItemsIndexes = []; // clear selection
    //   this.loadData();
    // },

    // makeASell() {
    //   this.hideModal();

    //   // prepare 'backOrder' meta data
    //   const ordersToRemove = {};
    //   for (let i = 0; i < this.selectedItems.length; i += 1) {
    //     const { id: orderId, productId } = this.selectedItems[i];

    //     if (!ordersToRemove[orderId]) {
    //       ordersToRemove[orderId] = [];
    //     }
    //     ordersToRemove[orderId].push(productId);
    //   }

    //   // convert from map -> array
    //   // const BACK_ORDERS = [];
    //   const BACK_ORDERS = Object.keys(ordersToRemove).map((key) => {
    //     return {
    //       orderId: key,
    //       productIds: ordersToRemove[key],
    //     };
    //   });
    //   console.log(BACK_ORDERS);

    //   const FIRST_ITEM = this.selectedItems[0];
    //   this.$router.push({
    //     name: 'cs.new-order', // can't use path, cause it WON'T allow passing hidden params
    //     params: {
    //       // ...this.selectedItem, // pass eveything inside the quotation
    //       products: this.selectedItems.map(elm => ({
    //         ...elm.product,
    //       })),

    //       // customerId: this.customer.id,
    //       customer: this.customer,

    //       ship_type: FIRST_ITEM.ship_type,
    //       ship_to: FIRST_ITEM.ship_to,
    //       remarks: FIRST_ITEM.remarks,
    //       has_vat: FIRST_ITEM.has_vat,
    //       package_carrier_id: FIRST_ITEM.package_carrier_id,
    //       // remarks: `จากใบเสนอราคาหมายเลข ${this.selectedItem.entryNo}`,

    //       backOrdersToRemove: BACK_ORDERS,
    //     },
    //   });
    // },
    // showStatusDialog() {
    //   this.$modal.show('action-status');
    // },
    // hideStatusDialog() {
    //   this.$modal.hide('action-status');
    // },
  },
  mounted() {
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,

    BackOrderDetail,
    QuotationDetail,
  },
};
</script>

<style lang="scss">
.back-order-list {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
